import axios from './http'

import de from "element-ui/src/locale/lang/de";

/**
 * 时间管理
 * @type {{register(): Promise<AxiosResponse<*>>}}
 */
const timeManage = {

  /**
   * 查询所有的时间
   * @returns {Promise<AxiosResponse<any>>}
   */
  getAllTime() {
    return axios.get('/thesis/timeNetWork')
  },

  /**
   * 修改所有时间
   * @param timeNetWorks
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateAll(timeNetWorks){
    return axios.put('/thesis/timeNetWork/updateAll',timeNetWorks)
  }
}

export default timeManage



// WEBPACK FOOTER //
// ./src/api/timeManage.js